"use strict";
/**
 * (C) Copyright 2023, Scaleton Labs LLC
 *
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoolType = void 0;
var PoolType;
(function (PoolType) {
    PoolType[PoolType["VOLATILE"] = 0] = "VOLATILE";
    PoolType[PoolType["STABLE"] = 1] = "STABLE";
})(PoolType || (exports.PoolType = PoolType = {}));
//# sourceMappingURL=PoolType.js.map